module.exports = __webpack_public_path__ + "media/יום.114f6d5c.mp3";